@if (rows().length) {
  <ul class="timeline__context" aria-label="Signal timeline legend" role="list">
    <li class="timeline__key">
      <span class="timeline__marker timeline__marker--signal" aria-hidden="true"></span>
      Pressure deviation
    </li>
    @if (hasEvents()) {
      <li class="timeline__key">
        <span class="timeline__marker timeline__marker--hatched" aria-hidden="true"></span>
        Onset uncertainty / sampling gaps
      </li>
      <li class="timeline__key">
        <span class="timeline__marker timeline__marker--settled" aria-hidden="true"></span>
        Settled shift
      </li>
      <li class="timeline__key">
        <span class="timeline__marker timeline__marker--settling" aria-hidden="true"></span>
        Settling (not recovery)
      </li>
      <li class="timeline__key">
        <i class="pi pi-arrow-right timeline__marker" aria-hidden="true"></i>
        No observed return
      </li>
    }
  </ul>
  <div class="timeline__chart" [style.height]="chartHeight()">
    <canvas
      [data]="chartData()"
      [options]="chartOptions()"
      [plugins]="eventPlugins"
      (chartClick)="onChartClick($event.active)"
      baseChart
      type="bar"
      role="img"
      aria-label="Signal timeline by asset. Select a pressure deviation signal to inspect its evidence.">
    </canvas>
  </div>
} @else {
  <p class="timeline__empty">No valid signal start timestamps are available.</p>
}